import sc from 'styled-components';
import {Dialog} from '@phonectas/unifon-ui-kit';

export interface StyledDialogProps {
    $width?: number;
    $noOverflow?: boolean;
    $maxHeight?: number;
    $noPadding?: boolean;
	open?: boolean;
	$noPaddingHeader?: boolean;
}

export const StyledCustomDialog = sc(Dialog)<StyledDialogProps>`
	width: ${({$width}) => typeof $width === 'number' ? `${$width}px` : '690px'};
	max-height: ${({$maxHeight}) => $maxHeight ? `${$maxHeight}vh` : '80vh'};
	flex-wrap: nowrap;
	padding:  ${({$noPadding}) => $noPadding ? '0' : '16px'};
	overflow: ${({$noOverflow}) => $noOverflow ? 'hidden' : 'auto'};
	box-sizing: border-box;
`;

export const DialogFooter = sc.div`
	display: flex;
	// justify-content: space-between;
	gap: 8px;
`;

export const DialogHeader = sc.div<StyledDialogProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: ${({$noPaddingHeader}) => $noPaddingHeader ? '0' : '16px 16px 0px 16px'};
`;

export const DialogTitle = sc.h2`
	font-size: 20px;
	margin: 0;
	color: #002266;
`;

export const CloseButton = sc.button`
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	padding: 0;
	color: #666;
`;

export const StyledDialogContent = sc.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;